jQuery(function ($) {
  $(".image-text__cta a[href='#']").on("click", function (e) {
    e.preventDefault();
    window.acronScrollTo(".form-banner");
  });

  $(document)
    .on("lity:ready", ".image-text__video-popup", function () {
      var video = $(this).find("video").get(0);

      if (video) {
        var playPromise = video.play();

        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(function () {});
        }
      }
    })
    .on("lity:remove", ".image-text__video-popup", function () {
      var video = $(this).find("video").get(0);

      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });
});
